<template>
    <div v-if="showDialog"
        class="body">
        <div class="content">
            <!-- 顶部图片 -->
            <img :src="img">
            <!-- 弹窗内容 -->
            <div class="content-text">
                <div class="failed-title">{{ text }}</div>
                <div class="failed-text">您当前签到距离超出范围，请到具体活动门店后在签到，点击查看具体门店名单</div>
                <div class="btn-tool align-center">
                    <Button class="btn-submit"
                        v-on:click.stop="toView">查看</Button>
                </div>
            </div>
            <div class="closeDialog">
                <van-icon name="cross"
                    @click="closeDialog()" />
            </div>
        </div>

    </div>
</template>
<script >
import { Icon } from 'vant';
export default {
  components: {
    [Icon.name]: Icon,
  },
  props: {
    showDialog: {
      type: Boolean,
      default: false,
    },
    img: String,
    text: String,
  },
  data() {
    return {};
  },
  methods: {
    toView() {
      this.$emit('toStoreNavigation');
    },
    closeDialog(){
      this.$emit('closeDialog');
    }
  },
};
</script>
<style lang="scss" scoped>
.body {
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  z-index: 1000;
  position: fixed;
  top: 0;
  align-items: center;
  display: flex;
  justify-content: center;
}
.content {
  width: 76.4%;
  max-height: 300px;
  min-height: 260px;
  display: flex;
  justify-content: center;
  position: relative;
  background-color: #ffffff;
  border-radius: 12px;
  align-items: center;
  img {
    width: 100px;
    height: 100px;
    position: absolute;
    top: -2vw;
  }
  .content-text {
    margin-top: 15vw;
    .failed-title {
      font-size: 18px;
      color: #000000;
      text-align: center;
      font-weight: 600;
    }
    .failed-text {
      font-size: 14px;
      color: #000000;
      text-align: center;
      padding: 15px;
    }
  }
  .closeDialog {
    width: 30px;
    height: 30px;
    border: 1px solid white;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    color: white;
    font-size: 22.5px;
    position: absolute;
    left: 50%;
    transform: translate(-50%, 200%);
    bottom: 15px;
  }
}

.btn-submit {
  background: #256fff;
  border-radius: 55px;
  font-size: 14px;
  color: #ffffff;
  width: 60%;
  height: 40px;
}
</style>


// WEBPACK FOOTER //
// src/page/vibrantRubikCube/runtime/sign-in-components/sign-in-failed-dialog.vue